<template>
    <vue-final-modal
        name="ModalIllustration"
        :transition="transition"
        :hide-overlay="windowWidth<769"
        classes="modal-container flex justify-center items-center"
        content-class="py-2.5 px-5 w-full h-full bg-white relative md:max-w-[64rem] md:max-h-[38rem] md:rounded-md flex flex-col"
        lock-scroll
        :click-to-close="false"
        :z-index-base="501"
    >
        <button
            class="btn btn-circle btn-ghost border-0 absolute right-0 top-0"
            @click.stop="$emit('closed')"
        >
            <SvgIcon
                icon-name="close"
                class="text-gray-900 w-6 h-6 cursor-pointer"
            />
        </button>
        <div class="text-lg xs:text-xl text-gray-900 font-bold pb-2.5">
            申請項目說明
        </div>
        <Multiselect
            v-model="currentContent"
            class="md:hidden"
            :options="contents"
            :can-clear="false"
            :can-deselect="false"
            object
            @select="currentItemCode = ''"
        />
        <div class="hidden md:block">
            <button
                v-for="content in contents"
                :key="content.value"
                class="rounded-md py-3 md:w-32 lg:w-40 md:text-base lg:text-lg text-center mr-2.5 last:mr-0 text-lg leading-[1.625rem] transition duration-200 "
                :class="[currentContent.value === content.value?'active':'default']"
                @click="setContent(content)"
            >
                {{ content.label }}
            </button>
        </div>
        <div
            ref="scrollContent"
            class="overflow-y-auto h-auto"
        >
            <div
                v-for="item in currentContent.list"
                :id="item.code"
                :key="item.title"
                class="collapse collapse-arrow border-b border-gray-200 md:mr-2.5"
                :class="[currentItemCode === item.code || currentContent.value ==='loan' ?'collapse-open':'collapse-close']"
            >
                <div
                    class="collapse-title sticky z-10 top-0 text-black font-bold pl-0 bg-white"
                    :class="{'hidden':currentContent.value ==='loan'}"
                    @click="setOpen(item.code)"
                >
                    {{ item.title }}
                </div>

                <div
                    v-if="currentItemCode === item.code"
                    class="collapse-content px-0"
                    :class="{'pt-1':currentContent.value ==='loan'}"
                >
                    <div
                        v-if="loadedCount<imgCount"
                        class="flex items-center justify-center h-40"
                    >
                        <SvgIcon
                            icon-name="loading-gray"
                            class="animate-spin h-10 w-10 mr-2"
                        />
                        <span class="text-lg text-gray-600 uppercase">loading</span>
                    </div>
                    <div
                        class="my-2.5"
                        :class="{'hidden': loadedCount<imgCount}"
                    >
                        <!-- 灰色區塊 -->
                        <div
                            v-if="item.grayContent"
                            class="rounded border border-gray-200 p-3.5 text-gray-900 mb-5 bg-gray-50 md:mr-2.5"
                        >
                            <span v-if="item.grayContent.title">{{ item.grayContent.title }}</span>
                            <ol
                                v-if="item.grayContent.ol"
                                :class="{'list-decimal list-inside':item.grayContent.ol.length > 1}"
                            >
                                <li
                                    v-for="li in item.grayContent.ol"
                                    :key="li"
                                    :class="{'indent-1':item.grayContent.ol.length > 1}"
                                >
                                    {{ li.text }}
                                </li>
                            </ol>
                            <div
                                v-if="item.grayContent.reminder"
                                class="text-error mb-2.5 last:mb-0"
                            >
                                <span>{{ item.grayContent.reminderTitle || '提醒：' }}</span><span
                                    v-for="content in item.grayContent.reminder"
                                    :key="content"
                                    :class="{'block indent-1':item.grayContent.reminder.length > 1}"
                                >
                                    {{ content.text }}
                                </span>
                            </div>
                            <div
                                v-if="item.grayContent.otherText"
                                class="mt-2.5 first:mt-0"
                            >
                                <div
                                    v-for="content in item.grayContent.otherText"
                                    :key="content"
                                    class="mb-2.5 last:mb-0"
                                >
                                    {{ content.text }}
                                </div>
                            </div>
                        </div>
                        <!-- 步驟 -->
                        <ol
                            v-if="item.stepOl"
                            class="step-ol"
                        >
                            <li
                                v-for="(step,index) in item.stepOl"
                                :key="index"
                            >
                                <div class="md:flex md:flex-wrap px-0.5 sm:px-0">
                                    <div class="md:w-1/3 md:pr-2">
                                        {{ step.content }}
                                        <!-- 步驟條列文字 -->
                                        <ol
                                            v-if="step.circleOl"
                                            class="circle-ol"
                                        >
                                            <li
                                                v-for="li in step.circleOl"
                                                :key="li"
                                            >
                                                {{ li.text }}
                                            </li>
                                        </ol>
                                    </div>

                                    <div
                                        v-if="item.code"
                                        class="max-w-[37.5rem] hidden md:block mx-auto shadow-3 mt-1.5 md:w-2/3 md:-mt-5"
                                    >
                                        <img
                                            :src="require(`@/assets/images/illustration/computer/${item.code}/${index < 9 ? `0${index + 1}` : index + 1}.png`)"
                                            class="w-full"
                                            @error="handleError"
                                            @load="loadedCount++"
                                        >
                                    </div>
                                    <div
                                        v-if="item.code"
                                        class="max-w-[21.875rem] md:hidden mx-auto shadow-3 mt-1.5"
                                    >
                                        <img
                                            :src="require(`@/assets/images/illustration/mobile/${item.code}/${index < 9 ? `0${index + 1}` : index + 1}.png`)"
                                            class="w-full"
                                            @error="handleError"
                                            @load="loadedCount++"
                                        >
                                    </div>
                                    <ul
                                        v-if="step.otherText"
                                        class="mt-2 md:mt-6"
                                    >
                                        <li
                                            v-for="(li,idx) in step.otherText"
                                            :key="idx"
                                            class="mb-4 last:mb-0 font-bold text-gray-800 md:flex"
                                        >
                                            <span class="md:w-1/3">{{ li.text }}</span>
                                            <div
                                                v-if="item.code"
                                                class="max-w-[37.5rem] hidden md:block mx-auto shadow-3 md:w-2/3 md:flex-shrink-0"
                                            >
                                                <img
                                                    :src="require(`@/assets/images/illustration/computer/${item.code}/${li.imgNumber}.png`)"
                                                    class="w-full"
                                                    @error="handleError"
                                                >
                                            </div>
                                            <div
                                                v-if="item.code"
                                                class="max-w-[21.875rem] md:hidden mx-auto shadow-3"
                                            >
                                                <img
                                                    :src="require(`@/assets/images/illustration/mobile/${item.code}/${li.imgNumber}.png`)"
                                                    class="w-full"
                                                    @error="handleError"
                                                >
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>
<script>
import { ref, computed, onMounted, nextTick, watchEffect, reactive } from 'vue';
import { toRefs, useEventListener } from '@vueuse/core';
import Multiselect from '@vueform/multiselect';
import IllustrationContent from '@/json/IllustrationContent';

export default {
    components: {
        Multiselect
    },
    emits: ['closed', 'confirm', 'cancel'],
    setup() {
        const scrollContent = ref(null);
        const windowWidth = ref(window.innerWidth);
        const contents = computed(() => [...IllustrationContent.data]);
        const data = reactive({
            currentContent: contents.value[0],
            currentItemCode: ''
        });
        const state = reactive({
            isLoadImgError: false,
            loadedCount: 0,
        });
        const imgCount = computed(() => {
            const index = data.currentContent.list.findIndex(i => i.code === data.currentItemCode);
            return index > 0 ? data.currentContent.list[index].stepOl.length : 0;
        });
        const transition = {
            'enter-active-class': 'transition duration-300 ease-in-out transform',
            'enter-from-class': 'translate-y-full',
            'enter-to-class': 'translate-y-0',
            'leave-active-class': 'transition duration-300 ease-in-out transform',
            'leave-to-class': 'translate-y-full',
            'leave-from-class': 'translate-y-0'
        };

        const setOpen = (code) => {
            data.currentItemCode === code ? data.currentItemCode = '' : data.currentItemCode = code;
            state.loadedCount = 0;
        };
        const setContent = (content) => {
            data.currentContent = content;
            data.currentItemCode = '';
        };

        const handleError = () => {
            state.isLoadImgError = true;
        };

        onMounted(() => {
            useEventListener(window, 'resize', (evt) => {
                windowWidth.value = window.innerWidth;
            });
        });

        watchEffect(() => {
            if (data.currentContent) {
                if (data.currentContent.value === 'loan') {
                    data.currentItemCode = data.currentContent.list[0].code;
                }
                nextTick(() => {
                    scrollContent.value.scrollTop = 0;
                });
            }

            if (data.currentItemCode) {
                nextTick(() => {
                    scrollContent.value.scrollTop = document.querySelector(`#${data.currentItemCode}`).offsetTop - 110;
                });
            }

            if (state.isLoadImgError) {
                sessionStorage.clear();
                const path = process.env.VUE_APP_CONTEXT_PATH;
                const baseUrl = `${window.location.origin}${path}`;
                setTimeout(() => {
                    window.location.assign(`${baseUrl}/err/401`);
                }, 500);
            }
        });

        return {
            setOpen,
            setContent,
            handleError,
            ...toRefs(data),
            ...toRefs(state),
            windowWidth,
            transition,
            contents,
            scrollContent,
            imgCount,
        };
    }
};
</script>

<style lang="scss" scoped>
.active {
    @apply text-white bg-gradient-to-r from-blue-300 to-green-300;
}
.default {
    @apply bg-gray-50 text-gray-700;
}

:deep(.step-ol) {
    counter-reset: step;
    > li {
        @apply relative mt-1 text-gray-900 mb-6 md:mb-8 last:mb-0;
        counter-increment: step;

        &::before {
            @apply w-2.5 h-2.5 bg-green-600 block my-2;
            content: "";
        }
        &::after {
            @apply text-green-600 text-base font-bold absolute top-[-0.5rem] left-4;
            content: "Step " counter(step);
        }
    }
}

:deep(.circle-ol) {
    counter-reset: circle;
    @apply mt-1;
    > li {
        counter-increment: circle;
        @apply relative pl-5 mb-1;
        &::before {
            @apply w-[1.125rem] h-[1.125rem] bg-gray-700 block mr-1 rounded-full text-white text-sm text-center absolute left-0 top-[0.2rem] leading-[1.125rem];
            content: counter(circle);
        }
    }
}

:deep(.collapse-arrow) .collapse-title:after {
    box-shadow: #999999 2px 2px 0px 0px;
    @apply right-3;
}

:deep(.modal-container) {
    .multiselect {
        @apply text-white bg-gradient-to-r from-blue-300 to-green-300 py-2.5 px-3.5 rounded-b-none border-none h-11;
        .multiselect-single-label {
            @apply font-bold;
        }
        .multiselect-caret {
            background-image: url("../../assets/images/arrows/chevron-down-white.svg");
            @apply mr-0 opacity-100 w-6 h-6;
        }
        .multiselect-dropdown {
            @apply border-none shadow-5 rounded-b-none text-gray-900 text-base xs:text-lg;
            .multiselect-options .multiselect-option {
                @apply py-2.5;
                &.is-pointed {
                    @apply bg-transparent;
                }
                &:hover,
                &.is-selected {
                    @apply bg-green-500 text-white;
                }
            }
        }
    }
}
</style>
